// 使いながら調整したい数値をここにまとめてある。
// 触るのはこのファイルだけでよい。

// ==========================================================
// タスク名の表示
// ==========================================================
// 文字数が増えたら、その段階で字を小さくする。
// 短い名前はそのままの大きさで表示される。
//
// 入力できる文字数に上限はない。
// Googleカレンダー側に上限がないので、そちらに合わせてある。
// 欄からはみ出したぶんは、横に流れる。

// スマホは画面が狭いので、今まで通り文字数に応じて小さくする。
// 目との距離が近いので、8pxでも読める。
// パソコン・タブレットは、まず 14px のまま何文字まで収まるかを見てから決める。

// ----- スマホ（画面の幅が700px以下）-----

/** この文字数を超えたら1段階小さくする */
export const NAME_SHRINK_1 = 20;

/** この文字数を超えたらもう1段階小さくする */
export const NAME_SHRINK_2 = 24;

/** 1段階小さくしたときの大きさ(px) */
export const NAME_SIZE_SM = 12;

/** もう1段階小さくしたときの大きさ(px) */
export const NAME_SIZE_XS = 8;

// ----- パソコン・タブレット横（画面の幅が700pxより広い）-----

/** ふだんの大きさ(px) */
export const NAME_SIZE_PC = 14;

/** 小さくしたときの大きさ(px) */
export const NAME_SIZE_PC_SM = 12;

/** この文字数を超えたら NAME_SIZE_PC_SM にする（999 = 小さくしない） */
export const NAME_SHRINK_PC = 999;

// 上の2つの大きさをCSSへ渡す。CSS側は変数を読むだけにしてあるので、
// この数値を書き換えれば、CSSを触らずに大きさを変えられる。
if (typeof document !== 'undefined') {
  const root = document.documentElement.style;
  root.setProperty('--name-size-pc', `${NAME_SIZE_PC}px`);
  root.setProperty('--name-size-pc-sm', `${NAME_SIZE_PC_SM}px`);
  root.setProperty('--name-size-sm', `${NAME_SIZE_SM}px`);
  root.setProperty('--name-size-xs', `${NAME_SIZE_XS}px`);
}

// ==========================================================
// 削除の取り消し
// ==========================================================

/** 「元に戻す」を出しておく時間（ミリ秒） */
export const UNDO_DURATION_MS = 3000;
